import m from "mithril";
import {ControlGroup, SelectList, ListItem, Button, Icon, Icons, Size} from "../../old/tools/constructui";

export default ({attrs: {items, onselect, placeholder = "Select", value, caption, nullable = true}}) => {
	let _val = value;

	function PerformOnSelect(val, onselect) {
		_val = val;
		onselect(val);
	}

	return {
		view: () => {
			// console.log({items});
			return m(ControlGroup, [
				m(SelectList, {
					closeOnSelect: true,
					// header: this.header ? m("h4", "Header content") : undefined,
					// footer: this.footer ? m("h4[style=margin: 15px 0 0 0]", "Footer content") : undefined,
					items,
					itemRender: (item) => {
						return m(ListItem, {
							// contentRight: m('', { style: `color:${Colors.BLUE_GREY200}` }, item.code),
							label: item.caption,
							selected: value && value === item.id,
						});
					},
					// contentRight: nullable && m(Button, {
					// 	IconRight: m(Icon, {
					// 		name: Icons.X_CIRCLE, onclick: () => {
					// 			PerformOnSelect(undefined, onselect);
					// 		}
					// 	})
					// }),
					itemPredicate: (query, item) => {
						return item.caption.toLowerCase().includes(query.toLowerCase());
					},
					onSelect: (val) => {
						PerformOnSelect(val, onselect);
					},
					// loading: this.loading,
					popoverAttrs: {
						autofocus: true,
						// inline: true,
						position: "right",
					},
					// 	hasArrow: true,
					// 	addToStack: true,
					// 	// popperOptions: {
					// 	// 	modifiers: [
					// 	// 		{
					// 	// 			name: "preventOverflow",
					// 	// 			options: {
					// 	// 				// Constrain popover inside the askbar dialog
					// 	// 				boundary:
					// 	// 					document.querySelector(".cui-dialog.full-width, .full-width.cui-dialog, .full-width") ||
					// 	// 					document.body,
					// 	// 				padding: 8,
					// 	// 			},
					// 	// 		},
					// 	// 		{
					// 	// 			name: "flip",
					// 	// 			options: {
					// 	// 				boundary:
					// 	// 					document.querySelector(".cui-dialog.full-width, .full-width.cui-dialog, .full-width") ||
					// 	// 					document.body,
					// 	// 			},
					// 	// 		},
					// 	// 	],
					// 	// },
					// },
					trigger: m(Button, {
						align: "left",
						size: Size.XS,
						// fluid: true,
						// compact: true,
						iconRight: Icons.CHEVRON_DOWN,
						// sublabel: "Country:",
						label: _val?.caption || _val?.id || value?.caption || value?.id || caption || value || placeholder,
						// style: "min-width: 300px",
					}),
				}),
				nullable &&
					m(Button, {
						iconLeft: Icons.X_CIRCLE,
						size: Size.XS,
						onclick: () => {
							PerformOnSelect(undefined, onselect);
						},
					}),
			]);
		},
	};
};
